import { PartialWindow } from "@func-core/core/types";
import { getAnonymousId } from "@func-core/core/utils/browser-features";
import { getWindow } from "@utils/browser-features";
import { handleResponseError } from "@utils/error-utils/response-error-handlers";

const getDefaultOptions = (): Record<string, Record<string, string> | string> => ({
  credentials: "same-origin",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.GATSBY_API_TOKEN}`,
    "X-Anonymous-Id": getAnonymousId(getWindow() as PartialWindow),
  },
});

export async function fetchApi<T>(url: string, params: Record<string, unknown> = {}): Promise<T> {
  const requestOptions: RequestInit = { ...getDefaultOptions(), ...params };

  return fetch(url, requestOptions).then(async (res: Response): Promise<T> => {
    if (!res.ok) {
      await handleResponseError(res);
    }

    return res as unknown as T;
  });
}

export async function fetchApiJson<T>(
  url: string,
  params: Record<string, unknown> = {}
): Promise<T> {
  const requestOptions: RequestInit = { ...getDefaultOptions(), ...params };

  return fetch(url, requestOptions).then(async (res: Response): Promise<T> => {
    if (!res.ok) {
      await handleResponseError(res);
    }

    return res.json();
  });
}
